import React, { useCallback, useEffect, useState } from 'react';
import { Card, Badge, FadeIn, Empty } from '../components/ui';
import { rupee } from '../theme';
import NotificationBell from '../components/NotificationBell';
import api from '../api/client';
import { demoJobs } from '../api/demo';

const tone = { assigned: 'warning', in_progress: 'brand', completed: 'success', cancelled: 'neutral' };

export default function StaffJobs() {
  const [jobs, setJobs] = useState(demoJobs);
  const [loaded, setLoaded] = useState(false);
  const [refreshing, setRefreshing] = useState(false);

  const load = useCallback(() => api.get('/bookings')
    .then((d) => { if (Array.isArray(d?.bookings) && d.bookings.length > 0) setJobs(d.bookings); })
    .catch(() => {})
    .finally(() => { setLoaded(true); setRefreshing(false); }), []);

  useEffect(() => { load(); }, [load]);
  const onRefresh = () => { setRefreshing(true); load(); };

  return (
    <div className="screen">
      <div className="page-head row-between">
        <div className="grow">
          <h1>My Jobs</h1>
          <p>Jobs assigned to you by the admin</p>
        </div>
        <div className="row" style={{ gap: 8 }}>
          <button className="chip" onClick={onRefresh} disabled={refreshing}>
            {refreshing ? '…' : '↻'}
          </button>
          <NotificationBell dark />
        </div>
      </div>

      <div className="booking-grid">
        {jobs.length === 0 ? (
          <Empty icon="🧰" title={loaded ? 'No jobs assigned yet' : 'Loading jobs…'}
            sub="The admin assigns jobs to you. New assignments appear here with a WhatsApp alert." />
        ) : jobs.map((job, i) => (
          <FadeIn key={job._id || i} delay={i * 70}>
            <Card style={{ height: '100%' }}>
              <div className="row-between">
                <span style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--primary)' }}>{job.bookingCode || '—'}</span>
                <Badge label={(job.status || 'assigned').replace('_', ' ')} tone={tone[job.status] || 'neutral'} />
              </div>
              <div style={{ fontSize: 16, fontWeight: 700, marginTop: 10 }}>{job.packageTitle || 'Service'}</div>

              <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
                <span className="muted" style={{ fontSize: 13 }}>👤 {job.customer?.name || 'Customer'}</span>
                {job.customer?.mobile ? (
                  <a href={`tel:+91${String(job.customer.mobile).slice(-10)}`}
                    style={{ fontSize: 13, color: 'var(--success)', fontWeight: 700 }}>
                    📞 {job.customer.mobile}
                  </a>
                ) : null}
                <span className="muted" style={{ fontSize: 13 }}>
                  📍 {job.address?.city || '—'} · {job.address?.pincode || ''}
                </span>
              </div>

              <div className="row-between" style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid var(--border)' }}>
                <span className="muted" style={{ fontSize: 13, fontWeight: 600 }}>Monthly pay</span>
                <span style={{ fontSize: 18, fontWeight: 800, color: 'var(--success)' }}>{rupee(job.staffPay)}</span>
              </div>

              <p className="faint" style={{ fontSize: 11.5, marginTop: 10, marginBottom: 0 }}>
                ℹ️ Assigned by admin — contact support for any changes.
              </p>
            </Card>
          </FadeIn>
        ))}
      </div>
    </div>
  );
}
